import { render, staticRenderFns } from "./projectManagement.vue?vue&type=template&id=655259e9&scoped=true"
import script from "./projectManagement.vue?vue&type=script&lang=js"
export * from "./projectManagement.vue?vue&type=script&lang=js"
import style0 from "./projectManagement.vue?vue&type=style&index=0&id=655259e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655259e9",
  null
  
)

export default component.exports